export default "__VITE_ASSET__ClwJd1cE__"